import img1 from "../../assets/Images/Event Booking/Refund-Voucher-List.png"
import img2 from "../../assets/Images/Event Booking/Create-Refund-Voucher.png"

export default function RefundVouchers() {
    return (
        <section id="refund-voucher" className="space-y-16">

            {/* SECTION TITLE */}
            <div>
                <h2 className="text-xl font-semibold text-[#C9A24E] mb-3">
                    2.8 Refund Vouchers
                </h2>
                <p className="text-slate-600 max-w-3xl">
                    The Refund Voucher module is used to record and manage refunds issued
                    against cancelled or adjusted bookings. It ensures financial accuracy
                    and maintains a clear audit trail for refunded amounts.
                </p><br />
                <p className="text-slate-600">
                    Refund vouchers are generated when an amount needs to be returned to a
                    customer due to booking cancellation, overpayment, or special approval.
                    Each refund is linked to a booking for traceability.
                </p>
            </div>

            {/* OVERVIEW */}
            {/* <section className="bg-white border-l border-[#C9A24E] p-4">
                <h3 className="text-lg font-semibold mb-2">
                    Overview
                </h3>
                
            </section> */}

            {/* NAVIGATION */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Navigation & Access
                </h3>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    {/* <li>
                        Accessible from <strong>Event Bookings → Refund Vouchers</strong>
                    </li> */}
                    <li>
                        Displays all refund vouchers created in the system
                    </li>
                    <li>
                        Helps accounts teams track outgoing payments
                    </li>
                </ul>
            </section>

            {/* REFUND LIST */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Refund Voucher List
                </h3>

                <p className="text-slate-600 mb-4">
                    This table displays all refund vouchers along with booking references
                    and payment details.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Refund voucher number (RF No)</li>
                    <li>Related booking number</li>
                    <li>Refund date</li>
                    <li>Refunded amount</li>
                    <li>Paid to (customer or party)</li>
                    <li>Payment method (Cash, Bank, Online)</li>
                </ul>

                 <div className=" rounded-lg p-4 mt-4">
                   <img src={img1} alt="" />
                </div>
            </section>

            {/* FILTERS */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Filters & Search
                </h3>

                <p className="text-slate-600 mb-3">
                    Filters allow users to quickly locate specific refund records.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Filter by date range</li>
                    <li>Filter by payment method</li>
                    <li>Instant search by voucher number or booking</li>
                </ul>
            </section>

            {/* ACTIONS */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Actions Available
                </h3>

                <p className="text-slate-600 mb-4">
                    Each refund voucher row includes the following actions:
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Print</strong> — Generates a printable refund voucher
                    </li>
                    <li>
                        <strong>Edit</strong> — Allows updating refund details (with permission)
                    </li>
                    <li>
                        <strong>Delete</strong> — Permanently removes the refund voucher
                    </li>
                </ul>
            </section>

            {/* ADD REFUND */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Creating a New Refund Voucher
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Add Refund</strong> button opens the refund
                    voucher creation form.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Auto-generated refund voucher number</li>
                    <li>Select cancelled booking</li>
                    <li>Refund date</li>
                    <li>Paid to (customer or party)</li>
                    <li>Refund amount</li>
                    <li>Payment method</li>
                </ul>

                <div className=" rounded-lg p-4 mt-4">
                   <img src={img2} alt="" />
                </div>
            </section>

            {/* SAVE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Saving the Refund Voucher
                </h3>

                <p className="text-slate-600">
                    Once saved, the refund voucher is recorded in the system, totals are
                    updated, and the transaction becomes part of financial reports and
                    audit logs.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1 mt-3">
                    <li>Refund is linked to the original booking</li>
                    <li>Accounts data is updated automatically</li>
                    <li>Voucher becomes printable and traceable</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Refund Vouchers Matter
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Proper refund tracking prevents disputes, ensures financial transparency,
                    and maintains trust with customers. It also provides management with
                    clear visibility into outgoing payments and adjustments.
                </p>
            </section>

        </section>
    );
}
